import React from "react";
import Glimmer from "@components/Glimmer";
import {useTwMediaQuery} from "../../../../../../../hooks/useTwMediaQuery";
import {Breakpoint} from "../../../../../../../constants/breakpoint";

const bigWidth = 85;
const smallWidth = 20;
const bigStyle = {borderRadius: 49, flexBasis: bigWidth} as const;
const smallStyle = {borderRadius: 99999, flexBasis: smallWidth} as const;
const SelectButtonLoading = () => {
  const isBig = useTwMediaQuery(Breakpoint.SM);

  return isBig ? (
    <div className="flex items-center basis-[85px] p-y-[10px] p-x-[20px]">
      <Glimmer height={54} style={bigStyle} />
    </div>
  ) : (
    <div className="flex items-center basis-[20px]">
      <Glimmer height={28} width={smallWidth} style={smallStyle} />
    </div>
  );
};

export default React.memo(SelectButtonLoading);
